import ArticleWordApi from './ArticleWordApi';
export default ArticleWordApi;
